// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3MBxU","errorLogs":"EditorFooter_errorLogs__2cLTA"};